import React from "react";
import { useContext } from "react";
import { MemoryLevelContext } from "../Context/MemoryLevelContext";

const ReturnButton = () => {

    const {unsetLevels} = useContext(MemoryLevelContext);

    return(
        <div className="return-button-container">
            <span className="button-container">
                <button className="button red" onClick={() => unsetLevels()}>            
                    <span className="label button--label">Tillbaka</span>
                </button>
            </span>
        </div>
    );
};

export default ReturnButton;